export function adjustStateName({ stateName, isTitleCase = false }) {
  if (stateName === 'District of Columbia') {
    return isTitleCase ? `The ${stateName}` : `the ${stateName}`;
  }
  return stateName;
}
